$(document).ready(function(){
	if (!$("body").hasClass("post-type-archive-adac_showroom") && 
		!$("body").hasClass("page-showrooms") && 
		!$("body").hasClass("page-designers-and-architects")) return;

	console.log("showrooms.js archive");

	// sorts all the showroom elements based on their data-sortname attributes.
	$('.showrooms-list .showroom').sortElements(function(a, b){
		return $(a).data('sortname') > $(b).data('sortname') ? 1 : -1;
	});
	

	defaultView();

	$("#search_by").on("change", function() {
		$(".showroom_search_options").hide();

		$("#showroom_name_search").val("").removeClass("inuse");
		$("#showroom_category_search").removeClass("inuse").find("option").first().prop('selected', true);
		$("#showroom_line_search").removeClass("inuse").find("option").first().prop('selected', true);

		nameSearch();
		categorySearch();
		lineSearch();

		if ($(this).val() == "none") {
			// show none
		} else if ($(this).val() == "name") {
			$("#showroom_name_search").show();
		} else if ($(this).val() == "category") {
			$("#showroom_category_search").show();
		} else if ($(this).val() == "lines") {
			$("#showroom_line_search").show();
		}
	});

	
	$("#showrooms_or_designers").on("change", function() {
		$(".showroom").removeClass("hidden_by_default");
		if ($(this).val() == "all") {
			$(".showroom").removeClass("hidden_by_filter")
		} else if ($(this).val() == "showrooms") {
			$(".showroom[data-type='showroom']").removeClass("hidden_by_filter");
			$(".showroom[data-type='designer']").addClass("hidden_by_filter");
		} else if ($(this).val() == "designer") {
			$(".showroom[data-type='showroom']").addClass("hidden_by_filter");
			$(".showroom[data-type='designer']").removeClass("hidden_by_filter");
		}
	})



	if (showroomListHiddenByDefault) {
		$(".only-buttons li").removeClass("active");
	}


	// check if url ends with showrooms
	if (showroomListHiddenByDefault && (document.referrer.indexOf("showrooms") == document.referrer.length - 10 || document.referrer.indexOf("showrooms") == document.referrer.length - 9)) {
		$("#back_to_search").show();
	}
	$("#back_to_search").on("click", function() {
		window.history.back();
	})



	
	$("#showroom_name_search").on("keyup", nameSearch);
	
	
	$(".showroom_search").on("blur change", function() {
		console.log("search blur");
		if ($(this).val() == $(this).attr("data-default") || !$(this).val() || !$(this).val().trim()) {
			$(this).val($(this).attr("data-default"));
			$(this).removeClass("inuse");
			defaultView();
		} else {
			
		}
		
	}).on("change", function() {
		console.log("search blur");
		if ($(this).val() == $(this).attr("data-default") || !$(this).val() || !$(this).val().trim()) {
			//do nothing.
			//blurring with not content should simply replace the placeholder content
		} else {
			if ($(window).innerWidth() < 768) {
				// console.log("search blur with val and mobile");
				scrollToList();
			}
		}
		
	});
	
	
	allShowrooms = $(".showroom").get();
	allShowroomNames = [];
	allShowroomLines = [];
	allShowroomCategories = [];
	
	for (var s in allShowrooms) {
		var name = $(allShowrooms[s]).children().first().html();
		name = cleanUp(name);
		allShowroomNames.push(name);
		
		var linesString = $(allShowrooms[s]).attr("data-lines");
		allShowroomLines.push(linesString);
		
		var cats = $(allShowrooms[s]).attr("data-categories");
		allShowroomCategories.push(cats);
	}
	// console.log(allShowroomLines);
		
	

	$("#showroom_category_search").on("change", categorySearch);
	$("#showroom_line_search").on("change", lineSearch);
	
	
	
	if ($("#showroom_name_search").val()) nameSearch();
	if ($("#showroom_category_search").val()) categorySearch();
	if ($("#showroom_line_search").val()) lineSearch();
	



	function scrollToList() {
		console.log("scroll to list");
		$.scrollTo($(".showrooms .showroom"), 400);
	}



	function cleanUp(a) {
		a = $.trim(a);
		a = a.replace(/&amp;/, " ");
		a = a.replace(/[^a-z0-9 ]/gi,' ');
		a = a.replace("  ", " ");
		a = a.replace("  ", " ");
		return a;
	}

	function makeAlphaNumeric(str) {
		if (!str) return;
		var lastLength;
		while (str.length != lastLength) { // loops until it does it and there's no change in string length
			lastLength = str.length;
			str = str.replace(/[^A-Za-z0-9]/, "");
		}
		return str;
	}






	//function delayedCategorySearch() {
	//	setTimeout(categorySearch, 300);
	//}

	function categorySearch() {
		
		$("#showroom_name_search").val("").removeClass("inuse");;
		//$("#showroom_category_search").removeClass("inuse").find("option").first().prop('selected', true);
		$("#showroom_line_search").removeClass("inuse").find("option").first().prop('selected', true);
		
		if ($.trim($("#showroom_category_search").val().length) && $("#showroom_category_search").val()) {
			// searching by name
			var needle = ' ' + $("#showroom_category_search").val() + ' ';
			console.log("needle: " + needle);
			
			var anyShowing = false;
			var i = 0;
			for (i=0; i<allShowroomCategories.length; i++) {
				var haystack = allShowroomCategories[i];
				if (haystack.includes(needle)) {
					anyShowing = true;
					$(allShowrooms[i]).removeClass("hidden_by_search").removeClass("hidden_by_default");
				} else {
					$(allShowrooms[i]).addClass("hidden_by_search");
				}
			}
			if (!anyShowing) {
				$(".noshowrooms").slideDown();
			} else {
				$("#showroomindividualtoprule").show();
				$(".columnheadings").slideDown();
				$(".noshowrooms").slideUp();

				if ($(window).innerHeight() < 600) {
					$.scrollTo(".showrooms .showroom:visible", 500);
				}
			}

		} else {
			defaultView();
		}
		

	}









	function delayedLineSearch() {
		setTimeout(lineSearch, 300);
	}

	function lineSearch() {
		
		$("#showroom_name_search").val("").removeClass("inuse");;
		$("#showroom_category_search").removeClass("inuse").find("option").first().prop('selected', true);
		//$("#showroom_line_search").removeClass("inuse").find("option").first().prop('selected', true);
		
		console.log('lineSearch: ', $("#showroom_line_search").val());

		if ($.trim($("#showroom_line_search").val().length) && $("#showroom_line_search").val()) {
			// searching by name
			var needle = ' ' + $("#showroom_line_search").val() + ' ';
			
			console.log("needle: " + needle);
			

			var anyShowing = false;
			var i = 0;
			for (i = 0; i < allShowroomLines.length; i ++) {
				var haystack = allShowroomLines[i];
				
				// console.log(haystack.includes(needle), haystack, needle);

				if (haystack.includes(needle)) {
					anyShowing = true;
					$(allShowrooms[i]).removeClass("hidden_by_search").removeClass("hidden_by_default");
				} else {
					$(allShowrooms[i]).addClass("hidden_by_search");
				}
			}
			if (!anyShowing) {
				$(".noshowrooms").slideDown();
			} else {
				$("#showroomindividualtoprule").show();
				$(".columnheadings").slideDown();
				$(".noshowrooms").slideUp();

				if ($(window).innerHeight() < 600) {
					$.scrollTo(".showrooms .showroom:visible", 500);
				}
			}

		} else {
			defaultView();
		}
	}





	function nameSearch() {
		
		//$("#showroom_name_search").val($("#showroom_name_search").attr("data-default")).removeClass("inuse");;
		$("#showroom_category_search").removeClass("inuse").find("option").first().prop('selected', true);
		$("#showroom_line_search").removeClass("inuse").find("option").first().prop('selected', true);
		
		if ($.trim($("#showroom_name_search").val().length) && $("#showroom_name_search").val() != "showroom name") {
			console.log("searching by name");
			// searching by name
			var needle = cleanUp($("#showroom_name_search").val());
			var anyShowing = false;
			var i = 0;
			for (i=0; i<allShowroomNames.length; i++) {
				var haystack = allShowroomNames[i];
				var c = (new RegExp(needle, 'i')).test(haystack);
				if (c) {
					anyShowing = true;
					$(allShowrooms[i]).removeClass("hidden_by_search").removeClass("hidden_by_default");
				} else {
					$(allShowrooms[i]).addClass("hidden_by_search");
				}
			}
			if (!anyShowing) {
				$(".noshowrooms").slideDown();
			} else {
				$("#showroomindividualtoprule").show();
				$(".columnheadings").slideDown();
				$(".noshowrooms").slideUp();


				if ($("#showroom_name_search:focus").length == 0 && $(window).innerHeight() < 600) {
					$.scrollTo(".showrooms .showroom:visible", 500);
				}
			}

		} else {
			defaultView();
		}
		
	}



	function defaultView() {
		if (showroomListHiddenByDefault) {
			hideAll();
		} else {
			showAll();
		}
	}


	function showAll() {
		try {console.log("showAll()");} catch (e) {};
		$("#showroomindividualtoprule").show();
		$(".columnheadings").slideDown();
		$(".showroom").removeClass("hidden_by_search").removeClass("hidden_by_filter").removeClass("hidden_by_default");
		$(".noshowrooms").slideUp();
		
		if (showroomListHiddenByDefault) $("#showroom_search_reset").val("hide results");
	}


	var hideAll = function() {
		try {console.log("hideAllSlow()");} catch (e) {};
		$("#showroomindividualtoprule").hide();
		$(".columnheadings").hide();
		$(".showroom").addClass("hidden_by_default");
		$(".noshowrooms").hide();
		
		if (showroomListHiddenByDefault) $("#showroom_search_reset").val("show all");
	}











});